export default {
    bathroom: 'Bathroom',
    furniture: 'Furniture',
    kitchen: 'Kitchen',
    qrcodeSummary: "Scan the QR code with your smartphone to see the product in augmented reality",
    seeinar: 'View in AR',
    storage: 'Storage',
}